import { ca } from '@cian/analytics';

import { EMapTypes } from '../constants/map';

/**
 * Переключение карты на отображение вида со спутника или на отображение схемы
 * @param {EMapTypes} mapType тип карты, на которую выполнили переключение
 */
export const trackSwitchMap = (mapType: EMapTypes) => {
  ca('event', {
    category: 'Card_KP',
    label: mapType === EMapTypes.map ? 'schema' : 'satellite',
    name: 'oldevent',
    action: 'switch_map',
    page: {
      pageType: 'CardKP',
    },
  });
};
